
export function executeCustomJSFromConfigList(configList) {
  let leftovers = [];
  let customJS = [];
  configList.forEach(d => {
    if (d.Name.indexOf('CustomJS_') == 0) {
      customJS.push(d.Value);
    } else {
      leftovers.push(d);
    }
  });

  // execute customJS
  let js = null;
  try {
    for (js of customJS) {
      if (js) {
        eval(js);
      }
    }
  } catch (ex) {
    console.warn('CUSTOM JS Error: ', ex);
    console.warn('CUSTOM JS Text: ', js);
  }

  return leftovers;
}
